<template>
  <div class="relative min-w-[300px] aspect-[9/16] rounded-[20px] overflow-hidden shadow-lg">
    <!-- Video element -->
    <video ref="videoRef" class="w-full h-full object-cover" :src="data.video" playsinline preload="none" :controls="isPlaying"
      @ended="handleVideoEnd" @pause="handleVideoPause" />

    <!-- Custom thumbnail overlay - se muestra cuando NO está reproduciendo -->
    <div v-if="!isPlaying" @click="playVideo" class="w-full h-full absolute inset-0 cursor-pointer bg-white">
      <img :src="data.img" :alt="`Miniatura de ${data.nombre}`" class="w-full h-full object-cover" loading="lazy" decoding="async" />
      <button class="absolute bottom-4 right-4 backdrop-blur-lg rounded-3xl p-3 w-[70px] h-[70px] flex justify-center items-center border-white text-white border shadow-md group z-10">
        <img src="/img/newhome/resenas/button-play-icon.webp" alt="play-icon" class="transition-all group-hover:scale-110 duration-700" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
});

const isPlaying = ref(false);
const videoRef = ref(null);

function playVideo() {
  isPlaying.value = true;
  if (videoRef.value) {
    videoRef.value.play();
  }
}

function handleVideoEnd() {
  isPlaying.value = false;
}

function handleVideoPause() {
  isPlaying.value = false;
}
</script>